import { render, staticRenderFns } from "./HealthcareApplicantCard.vue?vue&type=template&id=63b04d65&scoped=true&"
import script from "./HealthcareApplicantCard.vue?vue&type=script&lang=js&"
export * from "./HealthcareApplicantCard.vue?vue&type=script&lang=js&"
import style0 from "./HealthcareApplicantCard.vue?vue&type=style&index=0&id=63b04d65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b04d65",
  null
  
)

export default component.exports